import type { ComponentProps } from "react";

// 章の頭の合図は、見出しの1文字目の前に置く小さな下向き三角
// （before 擬似要素）と mt-16 の余白。以前は文字の上に短い緑バーを
// 敷いていたが、線だと「ここで区切る」の意味しか持てず、下に本文が
// 続くことを指せない。三角は行の中に入れる。上に別行で置くと、
// 見出しが2段になって余白の取り方が読めなくなる。
//
// **三角はデザインシステムに既にある形を使う。** 枠線で自作すると
// 角の丸みが他のアイコンと揃わない。content に ▼ を入れる案は、
// 字形がフォント任せで大きさが揃わないうえ読み上げにも乗るので取らない。
// 本文の字体 (Noto Sans JP) は 400/700 の2ウェイトだけを読むので、font-bold は
// ちゃんと 700 で出る（font-medium は実質 400 に落ちる）。
// 左ボーダーは以前ユーザー指定で削除されたので使わない。
// 三角は border-t-primary で、ダークでは primary-300 に切り替わる
export function MarkdownSectionHeading({ children, ...props }: ComponentProps<"h2">) {
  return (
    <h2
      /* text-wrap: balance。390px で「CIA——守る目的を3つに整理す / る」と
         最後の 1 文字だけが次の行に落ちていた。行を均すと 2 行に分かれても
         見出しとして読める。balance は日本語を字の間のどこでも切るので、
         「20 文 / 字で」のように語の途中で折れた。auto-phrase で文節の
         切れ目を優先する (対応しない版では今までどおり) */
      className="font-sans text-[22px] font-bold leading-[1.4] tracking-wide text-main mt-16 mb-6 first:mt-0 [text-wrap:balance] supports-[word-break:auto-phrase]:[word-break:auto-phrase] md:text-[26px]"
      {...props}
    >
      {/* 形は PlayIcon (Icon/PlayIcon.tsx) と同じ三角。角が丸めてある
         ぶん、枠線で描いた素の三角より柔らかい。あちらは #05B45B の
         直書きでダークに追従しないので、パスだけ借りて色は
         --color-border-primary から取る。三角の色をいままで決めて
         いたのがこの変数で、ダークでは primary-300 に切り替わる */}
      <svg
        width="26"
        height="26"
        viewBox="0 0 20 20"
        fill="none"
        aria-hidden="true"
        className="mr-1 inline-block rotate-90 align-middle text-[color:var(--color-border-primary)]"
      >
        <path
          d="M6.25 3.75L15.625 10L6.25 16.25V3.75Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {children}
    </h2>
  );
}
